module.exports = __webpack_public_path__ + "static/media/img7.ed609d53.jpeg";